/* eslint-disable @typescript-eslint/no-explicit-any */

import { type JSX, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type RouteComponentProps, withRouter } from 'react-router-dom';

import styled from 'styled-components';

import CardsAccordion from '../../components/CardsAccordion';
import Page from '../../components/Page';
import { withAPIService } from '../../networking';
import { withStore } from '../../store';
import { HC_RECORD_TYPE } from '../../utils/constants';
import { logger } from '../logger';
import MultiShipTo from './MultiShipTo';

const CompanyCardWrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

interface ShipToPageProps extends RouteComponentProps {
  store: any;
  cards?: any[];
  dispatch?: any;
  apiService?: any;
}

function Component(props: ShipToPageProps): JSX.Element {
  const { store, cards = [] } = props;

  const { recordType } = store.customer;

  const multiShipTo = [HC_RECORD_TYPE.fullCustomer, HC_RECORD_TYPE.shipTo].includes(recordType);

  const { t } = useTranslation();

  const [expandedAccordion, setExpandedAccordion] = useState<number>(0);

  useEffect(() => {
    logger.info(`RED-CARPET-FE ShipTo Page`, {
      hcRequestId: store.customer.id
    });

    // intentionally unchanged
  }, []);

  const accordionCallback = (index: number) => {
    setExpandedAccordion(index);
  };

  return (
    <Page {...props} dispatch={props.dispatch}>
      {multiShipTo ? (
        <MultiShipTo store={store} cards={cards} dispatch={props.dispatch} apiService={props.apiService} />
      ) : (
        <>
          {cards.map(({ key, ...card }: any, index: number) => {
            const title = key === 'additionalAttachmentCard' ? t(`financial.${key}.title`) : t(`shipTo.${key}.title`);

            const { Component } = card;

            return (
              <CompanyCardWrapper key={key}>
                <CardsAccordion
                  accordionCallback={accordionCallback}
                  isOpen={expandedAccordion === index}
                  cardTitle={title}
                  cardIndex={index}
                >
                  <Component {...card} {...props} />
                </CardsAccordion>
              </CompanyCardWrapper>
            );
          })}
        </>
      )}
    </Page>
  );
}

const connectRouter = withRouter(Component);
const connectAPI = withAPIService(connectRouter);
const ShipToPage = withStore(connectAPI);

export default ShipToPage;
